import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEleveInscriptions } from './eleve.reducer';
import { genererFactureInscription } from 'app/entities/factures/facture.reducer';
import { Table, Tag, Space, Button, Grid } from 'antd';
import { RetweetOutlined } from '@ant-design/icons';
import { PaiementCard } from './PaiementsInscription';
import { TextFormat } from 'react-jhipster';
import { APP_TIMESTAMP_FORMAT } from 'app/config/constants';
import InscriptionModal from './InscriptionModal';
import { Link } from 'react-router-dom';

interface IInscriptionsTab {
  eleveId: string;
  isActive: boolean;
  ecoleId: string;
}
const { useBreakpoint } = Grid;
const InscriptionsTab: React.FC<IInscriptionsTab> = ({ eleveId, isActive, ecoleId }) => {
  const dispatch = useAppDispatch();
  const screens = useBreakpoint();
  const { entitiesInscriptions: inscriptions, loading } = useAppSelector(state => state.eleve);

  const [selectedInscription, setSelectedInscription] = useState<any | null>(null);

  const handleTogglePaiement = record => {
    if (selectedInscription?.id === record.id) {
      setSelectedInscription(null);
    } else {
      setSelectedInscription(record);
    }
  };

  useEffect(() => {
    if (isActive) {
      dispatch(getEleveInscriptions(eleveId));
    }
  }, [dispatch, eleveId, isActive]);

  const handleGenererFacture = inscriptionId => {
    dispatch(genererFactureInscription({ inscriptionId, eleveId }));
  };

  const inscriptionsColumns = [
    {
      title: 'Année Scolaire',
      dataIndex: 'anneeScolaireName',
      key: 'anneeScolaireName',
    },
    {
      title: 'Date Inscription',
      dataIndex: 'dateInscription',
      key: 'dateInscription',
      render: date => <TextFormat type="date" value={date} format={APP_TIMESTAMP_FORMAT} />,
    },
    {
      title: 'Classe',
      dataIndex: 'classe',
      key: 'classe',
    },
    {
      title: 'Montant',
      dataIndex: 'montant',
      key: 'montant',
    },
    {
      title: 'Statut',
      dataIndex: 'statutInscription',
      key: 'statutInscription',
      render: statut => <Tag color={statut === 'INSCRIT' ? 'green' : statut === 'VALIDEE' ? 'blue' : 'red'}>{statut}</Tag>,
    },
    {
      title: 'Options',
      key: 'actions',
      width: screens.xs ? 100 : 200,
      render: (_, record) => (
        <Space size="middle">
          <Button
            hidden={!(record.statutInscription === 'PROVISOIRE')}
            onClick={() => handleGenererFacture(record.id)}
            style={{
              background: '#7cec48',
              color: 'white',
              borderRadius: '8px',
              marginRight: '10px',
              border: '1px solid #7cec48',
            }}
          >
            <>
              <RetweetOutlined style={{ marginRight: '5px' }} />
              Générer Facture
            </>
          </Button>
          {record.statutInscription !== 'PROVISOIRE' && <Button onClick={() => handleTogglePaiement(record)}>Détails</Button>}
        </Space>
      ),
    },
  ];

  const inscriptionsData = inscriptions.map(inscription => ({
    id: inscription.id,
    anneeScolaireName: inscription.anneeScolaireName || 'vide',
    dateInscription: inscription.dateInscription || 'vide',
    statutInscription: inscription.statutInscription || 'NON_INSCRIT',
    supportId: inscription.supportId || 'vide',
    classe: inscription.classeName || 'vide',
    montant: inscription.montantInscription || 'vide',
    anneeScolaireId: inscription.anneeScolaireId || 'vide',
    eleveId: inscription.eleveId || 'vide',
    ecoleId: inscription.ecoleId || 'vide',
  }));

  return (
    <>
      {/* <h5 style={{ textAlign: 'center' }}>Historique des Inscriptions</h5> */}
      <InscriptionModal ecoleId={ecoleId} eleveId={eleveId} />
      <Table columns={inscriptionsColumns} dataSource={inscriptionsData} bordered pagination={false} loading={loading} />
      {selectedInscription && <PaiementCard record={selectedInscription} />}
    </>
  );
};

export default InscriptionsTab;
